
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/content-migrations/jst/MigrationConverter';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n      <option value=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">";
  if (helper = helpers.label) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.label); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</option>\n      ";
  return buffer;
  }

  buffer += "<h1>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.migration_converter")
  },data:data},helper ? helper.call(depth0, "content_migrations.migration_converter.header", "Import Content", options) : helperMissing.call(depth0, "t", "content_migrations.migration_converter.header", "Import Content", options)))
    + "</h1>\n\n<div class=\"control-group\">\n  <label class=\"control-label\" for=\"chooseMigrationConverter\"><strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.migration_converter")
  },data:data},helper ? helper.call(depth0, "content_migrations.migration_converter.import_from_label", "Content Type", options) : helperMissing.call(depth0, "t", "content_migrations.migration_converter.import_from_label", "Content Type", options)))
    + "</strong></label>\n  <div class=\"controls\">\n    <select id=\"chooseMigrationConverter\" class=\"span3\">\n      <option value=\"none\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.migration_converter")
  },data:data},helper ? helper.call(depth0, "content_migrations.migration_converter.default_option", "Select One", options) : helperMissing.call(depth0, "t", "content_migrations.migration_converter.default_option", "Select One", options)))
    + "</option>\n      ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.selectOptions), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </select>\n  </div>\n</div>\n\n<div id=\"converter\" aria-live=\"assertive\" aria-relevant=\"additions text\" aria-atomic=\"true\"></div>\n\n<div class=\"form-container\" style=\"display: none\">\n  <div id=\"overwrite-warning\" style=\"max-width: 34em\"></div>\n  <div class=\"controls control-height\">\n    <input class=\"cancelBtn btn btn-small\" type=\"button\" value=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.migration_converter")
  },data:data},helper ? helper.call(depth0, "content_migrations.migration_converter.cancel_migration", "Cancel", options) : helperMissing.call(depth0, "t", "content_migrations.migration_converter.cancel_migration", "Cancel", options)))
    + "\">&nbsp;&nbsp;<input id=\"submitMigration\" type=\"submit\" value=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.migration_converter")
  },data:data},helper ? helper.call(depth0, "content_migrations.migration_converter.import_migration", "Import", options) : helperMissing.call(depth0, "t", "content_migrations.migration_converter.import_migration", "Import", options)))
    + "\" class=\"btn btn-small btn-primary span2\" />\n  </div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  